import { Button, typography } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const DropdownButtonStyled = styled(Button)`
  padding: 0 1rem;
  height: 4.3rem;
  ${typography.bold[16]}
`;

export const DropdownOpenedButtonStyled = styled(Button)`
  border: 2px solid transparent;
`;
